'use client';

import { c as _c } from "react/compiler-runtime";
import React, { Suspense } from 'react';
import { SiteHeader } from '@/components/layout/site-header';
import { SiteFooter } from '@/components/layout/footer';
import { Heading } from '@/components/text/heading';
import { StrokeText } from '@/components/text/stroke-text';
import QuoteForm from '@/components/ui/get-a-quote-ui/quote-form';
export default function GetAQuotePage() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SiteHeader variant="solid" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="col-span-full text-sm uppercase tracking-widest text-muted">Especificação → Orçamento</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <header className="grid grid-cols-12 gap-4 border-b border-[color:color-mix(in_srgb,var(--color-ink)_18%,transparent)] pb-8">{t1}<Heading level="h1" id="q-head" className="col-span-full lg:col-span-8 text-[clamp(2.2rem,8vw,6.4rem)] leading-none tracking-tighter">PRECISA DA NOSSA <StrokeText>AJUDA?</StrokeText></Heading><p className="col-span-full lg:col-span-4 self-end text-lg text-ink-74">Entre em contato para receber um orçamento e uma especificação de microcimento personalizada.</p></header>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-paper text-ink min-h-screen">{t0}<main><section className="border-t border-line py-fluid-y px-fluid-x py-24" aria-labelledby="q-head"><div className="max-w-container-max mx-auto">{t2}<div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-12"><div className="lg:col-span-8"><Suspense fallback={null}><QuoteForm /></Suspense></div></div></div></section></main><SiteFooter /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}